unit UACLink;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics,
  VCL.TMSFNCGraphicsTypes, System.Rtti, VCL.TMSFNCDataGridCell,
  VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase, VCL.TMSFNCDataGridCore,
  VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid;

type
  TForm2 = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    wcACLink: TXDataWebClient;
    wdsACLink: TXDataWebDataSet;
    dsACLink: TDataSource;
    TMSFNCDataGridDatabaseAdapter1: TTMSFNCDataGridDatabaseAdapter;
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form2: TForm2;

implementation

{$R *.dfm}

procedure TForm2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  TMSFNCDataGridDatabaseAdapter1 := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcACLink := TXDataWebClient.Create(Self);
  wdsACLink := TXDataWebDataSet.Create(Self);
  dsACLink := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  TMSFNCDataGridDatabaseAdapter1.BeforeLoadDFMValues;
  wcACLink.BeforeLoadDFMValues;
  wdsACLink.BeforeLoadDFMValues;
  dsACLink.BeforeLoadDFMValues;
  try
    Name := 'Form2';
    Width := 640;
    Height := 480;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 480;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Sage Online Analysis Category';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 420;
    WebPanel3.Width := 640;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 24;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Select';
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 136;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Close';
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    TMSFNCDataGrid1.SetParentComponent(WebPanel1);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 60;
    TMSFNCDataGrid1.Width := 640;
    TMSFNCDataGrid1.Height := 360;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 2;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := TMSFNCDataGridDatabaseAdapter1;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 0;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('UACLink.WebPanel1.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('UACLink.WebPanel1.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('UACLink.WebPanel1.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('UACLink.WebPanel1.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('UACLink.WebPanel1.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('UACLink.WebPanel1.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('UACLink.WebPanel1.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('UACLink.WebPanel1.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('UACLink.WebPanel1.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    TMSFNCDataGrid1.RowCount := 1;
    TMSFNCDataGridDatabaseAdapter1.SetParentComponent(TMSFNCDataGrid1);
    TMSFNCDataGridDatabaseAdapter1.Name := 'TMSFNCDataGridDatabaseAdapter1';
    TMSFNCDataGridDatabaseAdapter1.Left := 304;
    TMSFNCDataGridDatabaseAdapter1.Top := 176;
    TMSFNCDataGridDatabaseAdapter1.Width := 26;
    TMSFNCDataGridDatabaseAdapter1.Height := 26;
    TMSFNCDataGridDatabaseAdapter1.Visible := True;
    wcACLink.SetParentComponent(Self);
    wcACLink.Name := 'wcACLink';
    wcACLink.Left := 96;
    wcACLink.Top := 212;
    wdsACLink.SetParentComponent(Self);
    wdsACLink.Name := 'wdsACLink';
    wdsACLink.Left := 144;
    wdsACLink.Top := 220;
    dsACLink.SetParentComponent(Self);
    dsACLink.Name := 'dsACLink';
    dsACLink.Left := 208;
    dsACLink.Top := 228;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    TMSFNCDataGridDatabaseAdapter1.AfterLoadDFMValues;
    wcACLink.AfterLoadDFMValues;
    wdsACLink.AfterLoadDFMValues;
    dsACLink.AfterLoadDFMValues;
  end;
end;

end.